<script>
export default {
    name: "UploadMedicalFiles",

    data() {

        return {
            document: {
                name: ``,
            },
        };
    },

    props: {
        showModal: Boolean,
        patient: {
            type: Object,
            required: true,
        },
        visit: {
            type: Object,
            required: true,
        },
    },

    methods: {
      saveUploadFile() {
          this.$root.loading = true;
          let url = `Files/PostMedicalFileDocument`;
              url += `?ID=${0}`;
              url += `&EncouterID=${0}`;
              url += `&PatientID=${this.patient.patienT_ID}`;
              url += `&VisitNo=${this.visit.visitId}`;
              url += `&DocName=${this.document.name}`;
              url += `&contentType=${this.$refs.file.files[0].type}`;
              url += `&UserName=${this.$root.username}`;

          const file = this.$refs.file.files[0];
          const formData = new FormData();
          formData.append('file', file);
          this.$http.post(url, formData).then(({ data }) => {
              this.$emit(`refresh`);
              this.$refs.file.value = null;
              this.document = {
                  name: ``,
              };
              this.$root.loading = false;
              this.$emit(`closeModal`);
              window.Swal.fire({ type: `success`, text: data, })
          }).catch(() => { this.$root.loading = false; })
      },
    },
}
</script>
<template>
<tail-modal :show="showModal" dimension="md:w-1/3 w-3/4">
  <template v-slot:title>
    <h5 class="font-medium text-sm">Upload File</h5>
  </template>
  <template v-slot:modal-body>
    <form id="file-upload-form" 
        @submit.prevent="saveUploadFile" 
        class="w-full flex flex-wrap items-center">
        <div class="w-1/2 p-1">
            <label for="grid-document-name" class="label-control">Document Name:</label>
            <input type="text"
                required 
                id="grid-document-name" 
                v-model.trim="document.name" 
                class="input-control input-sm text-xs">
        </div>
        <div class="w-1/2 p-1">
            <label for="grid-file" class="label-control">File:</label>
            <input type="file"
                required
                id="grid-file" 
                ref="file" 
                class="input-control input-sm text-xs">
        </div>
    </form>
  </template>
  <template v-slot:modal-footer>
    <button 
        class="btn-danger btn-sm text-xs rounded mr-6" 
        @click.prevent="$emit(`closeModal`)">
        <i class="fa fa-times"></i> Close</button>
    <button 
        form="file-upload-form"
        type="submit"
        class="btn-primary btn-sm text-xs rounded">
        <i class="fa fa-save"></i> Save</button>
  </template>
</tail-modal>
</template>
